export default class Constants {
    public static readonly THEME_COOKIE_KEY = "user-theme-preference"
    public static readonly MESSAGE_OF_THE_DAY_INDEX_COOKIE_KEY = "message-of-the-day-index"
    public static readonly LAPTOP_SUBSCRIBER_COOKIE_KEY = "laptop-subscriber"
    public static readonly GUMROAD_COURSE_PRODUCT_IDS = ["advanced-typescript", "bash-commands-and-scripting", "mastering-pipelines"]
    public static readonly LAPTOP_SUBSCRIBER_INTERVAL = 100;
    public static readonly CHRISFREW_IN_API_URL = "https://api.chrisfrew.in/api";
}
